// extracted by mini-css-extract-plugin
export default {"optionsContainer":"SegmentedControl_optionsContainer__-15xK","option":"SegmentedControl_option__+3fu5","selected":"SegmentedControl_selected__vmlxU"};